/**
 * Product Add-On Selector: Adds selected add-on product variants to cart
 * before the main product, so main product appears on top in cart.
 * Items added individually so one out-of-stock item doesn't block the rest.
 */
(function() {
  if (!document.querySelector('[data-addon-select]')) return;

  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

    if (urlStr.includes('/cart/add') && options && !options._isAddon) {
      var extras = getSelectedAddons();
      if (extras.length) {
        // Add each addon individually so one failure doesn't block the rest
        var chain = Promise.resolve();
        for (var k = 0; k < extras.length; k++) {
          (function(item) {
            chain = chain.then(function() {
              return originalFetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [item] }),
                _isAddon: true
              }).catch(function() { /* skip failed addon */ });
            });
          })(extras[k]);
        }
        // After all addons attempted, add the main product
        return chain.then(function() {
          return originalFetch.apply(window, [url, options]);
        });
      }
    }
    return originalFetch.apply(this, arguments);
  };

  function getSelectedAddons() {
    var selects = document.querySelectorAll('[data-addon-select]');
    var items = [];
    for (var i = 0; i < selects.length; i++) {
      var selectedOption = selects[i].options[selects[i].selectedIndex];
      // Check for multi-product add (e.g. A & D-Type adds both couplers)
      var multi = selectedOption && selectedOption.getAttribute('data-addon-multi');
      if (multi) {
        var ids = multi.split(',');
        for (var j = 0; j < ids.length; j++) {
          items.push({ id: parseInt(ids[j]), quantity: 1 });
        }
      } else {
        var val = selects[i].value;
        if (val) {
          items.push({ id: parseInt(val), quantity: 1 });
        }
      }
    }
    return items;
  }
})();
